module.exports = __webpack_public_path__ + "img/143.5.908d2d72.png";